import { Currency } from '../../../constants/currency';
import type { Condition } from '../../../hooks/useProductData';
import { getAmountRangeToString, getMinRateString } from '../../humanization';

export const getEkvajringConditions = (item): Condition[] => {
  // Обслуживание. Эквайринг, Итого в мес., QR-эквайринг

  const conditions = [];

  if (item.advantages?.includes('tagQr')) {
    conditions.push({ value: 'Да', description: 'QR-эквайринг' });
  }

  conditions.push({ value: `от ${item.calcPriceTerm ?? 0} ₽`, description: 'Итого в месяц' });

  const ekvajringFields = {
    from: item.priceAcquiringS,
    to: item.priceAcquiringSto,
  };
  conditions.push({ value: `${getMinRateString(ekvajringFields, true)}`, description: 'Эквайринг' });

  const cost = getAmountRangeToString({
    amountRange: { from: item.calcPriceEquipment, to: null },
    currency: Currency.RUB,
    prefix: true,
  });
  conditions.push({ value: cost, description: 'Обслуживание и аренда' });

  return conditions;
};
